import { render, staticRenderFns } from "./VerifyScreen.vue?vue&type=template&id=b9a8ebae&"
import script from "./VerifyScreen.vue?vue&type=script&lang=ts&"
export * from "./VerifyScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports